import { useQuery } from "react-query";
// Shop-link map reads — session-free so featured-strip hydration avoids GoTrue races.
import { supabasePublic as supabase } from "../../config/supabaseClient";
import { applyShoppableFilter } from "./carouselHelper";

export async function fetchShopLinkMap(
  username: string,
  userId: string,
  postIds: any[]
) {
  const ids = Array.from(
    new Set((postIds || []).map((id) => String(id || "").trim()).filter(Boolean))
  );
  if (!username || !userId || ids.length === 0) {
    return {} as Record<string, any>;
  }

  const { data, error } = await supabase
    .from(username)
    .select("post_id, shop_link")
    .eq("user_id", userId)
    .in("post_id", ids);

  if (error) {
    throw new Error(error.message);
  }

  const map: Record<string, any> = {};
  (data || []).forEach((row: any) => {
    map[String(row.post_id)] = row.shop_link;
  });
  return map;
}

export function attachShopLinks(
  posts: any[],
  shopLinkMap?: Record<string, any> | null
) {
  if (!Array.isArray(posts)) return [];
  if (!shopLinkMap) return posts;
  return posts.map((post) => ({
    ...post,
    shop_link: shopLinkMap[String(post?.post_id)] ?? post?.shop_link,
  }));
}

export function filterPostsWithShopLinks(
  posts: any[],
  status?: string,
  shopLinkMap?: Record<string, any> | null
) {
  return applyShoppableFilter(attachShopLinks(posts, shopLinkMap), status);
}

export function usePostShopLinkMap(
  username: string,
  userId: string,
  postIds: any[],
  enabled: boolean
) {
  const idsKey = (postIds || []).map(String).join(",");
  return useQuery(
    ["postShopLinkMap", userId, idsKey],
    () => fetchShopLinkMap(username, String(userId), postIds),
    {
      enabled: Boolean(enabled && username && userId && postIds?.length),
    }
  );
}
